import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { Rules } from 'utils/constants';

import {
	DateField,
	FormItem,
	PhoneField,
	SelectField,
	SubmitButton,
	TextField,
} from 'componets/form';
import { Paper } from 'componets/ui';

import { GENDER_OPTIONS, PersonalInformationProps } from './index';

import styles from '../../index.module.scss';

export const PersonalInformationCompany: FC<PersonalInformationProps> = ({
	maxDate,
	onChangeSelect,
	countriesOptions,
	country,
	loading,
}) => {
	const { t } = useTranslation();

	const formCompanyFields = [
		{
			name: 'companyName',
			component: <TextField label={t('companyNameText')} />,
			rules: [
				Rules.REQUIRED,
				Rules.MAX_LENGTH('companyName', 100),
				Rules.MIN_LENGTH('idNumber', 3),
			],
		},
		{
			name: 'idNumber',
			component: <TextField label={t('companyRegistrationNumberText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('idNumber', 255), Rules.MIN_LENGTH('idNumber', 3)],
		},
		{
			name: 'countryId',
			component: (
				<SelectField
					selectText={t('selectCountryText')}
					options={countriesOptions}
					placeholder={t('countryText')}
					onChange={onChangeSelect}
					isFilter
				/>
			),
			rules: [Rules.REQUIRED],
		},
		{
			name: 'city',
			component: <TextField label={t('cityText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('city', 50)],
		},
		{
			name: 'address',
			component: <TextField label={t('addressLabelText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('address', 255)],
		},
		{
			name: 'zip',
			component: <TextField label={t('zipCodeText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('zip', 20)],
		},
	];
	const formFields = [
		{
			name: 'firstName',
			component: <TextField label={t('firstNameText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('firstName', 100)],
		},
		{
			name: 'lastName',
			component: <TextField label={t('lastNameText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('lastName', 100)],
		},
		{
			name: 'dateOfBirth',
			component: <DateField maxDate={maxDate} label={t('dateOfBirthText')} />,
			rules: [Rules.REQUIRED, Rules.INVALID_DATE()],
		},
		{
			name: 'gender',
			component: (
				<SelectField
					options={GENDER_OPTIONS}
					placeholder={t('genderText')}
					selectText={t('selectGenderText')}
				/>
			),
			rules: [Rules.REQUIRED],
		},
		{
			name: 'phone',
			component: <PhoneField country={country} label="phoneMobileText" />,
			rules: [Rules.REQUIRED, Rules.PHONE('phone')],
		},
		{
			name: 'referralCode',
			component: <TextField label={t('referralCodeText')} />,
			rules: [Rules.MAX_LENGTH('referralCode', 255)],
		},
	];

	return (
		<>
			<Paper styleName={styles.blockForm} top={<>2 / 2</>}>
				<Typography.Title level={4} className={styles.contactInfo}>
					{t('companyInformationFormText')}
				</Typography.Title>

				{formCompanyFields.map(({ name, component, rules }) => (
					<FormItem key={name} name={name} rules={rules}>
						{component}
					</FormItem>
				))}
			</Paper>

			<Paper styleName={styles.blockForm}>
				<Typography.Title level={4} className={styles.contactInfo}>
					{t('companyRepresentativeText')}
				</Typography.Title>

				{formFields.map(({ name, component, rules }) => (
					<FormItem key={name} name={name} rules={rules}>
						{component}
					</FormItem>
				))}

				<SubmitButton text={t('continueText')} loading={loading} />
			</Paper>
		</>
	);
};
